// App.js
import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/webpages/Login";
import Dashboard from "./components/webpages/Dashboard";
import QuoteForm from "./components/webpages/QouteForm";
import SupportForm from "./components/webpages/SupportForm";
import NotifyMeForm from "./components/webpages/NotifyMeForm";
import ProtectedRoute from "./components/ProtectedRoute";
import CarInsuarance from "./components/webpages/CarInsuarance";
import JobApplications from "./components/webpages/JobApplications";
import PiInsuarance from "./components/webpages/PiInsuarance";
import ComplimentoryPi from "./components/webpages/ComplimentoryPi";

function App() {

  return (
    <Router>
      <Toaster />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/quote-form" element={<ProtectedRoute><QuoteForm /></ProtectedRoute>} />
        <Route path="/support-form" element={<ProtectedRoute><SupportForm /></ProtectedRoute>} />
        <Route path="/notifyme-form" element={<ProtectedRoute><NotifyMeForm /></ProtectedRoute>} />
        <Route path="/car-insuarance" element={<ProtectedRoute><CarInsuarance /></ProtectedRoute>} />
        <Route path="/job-applications" element={<ProtectedRoute><JobApplications /></ProtectedRoute>} />
        <Route path="/complimentory-pi" element={<ProtectedRoute><PiInsuarance /></ProtectedRoute>} />
        <Route path="/doctor-pi" element={<ProtectedRoute><ComplimentoryPi /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
